import LiveInputs from './../handlers/live_inputs'

onDomLoad(($dom) => {
  $dom[0]
    .querySelectorAll(
      "[data-behaviour='account-selector-modal'], [data-behaviour='external-account-selector-modal']"
    )
    .forEach((el) => {
      el.addEventListener('click', () => {
        const {
          name,
          objectId,
          objectType,
          objectLedgerId,
          range,
          value,
          defaultValue,
          valueType,
        } = el.dataset

        const external =
          el.dataset.behaviour === 'external-account-selector-modal'

        const parent = el.closest('[data-behaviour="live-inputs"]')
        const parentdataset = parent.dataset

        const updatePath = parentdataset.createPropertiesPath
        const ownerType = parentdataset.ownerType
        const ownerId = parseInt(parentdataset.ownerId)
        const ledgerId = parseInt(parentdataset.ledgerId)

        const ledgerLabel = document.getElementById('ledger-label')?.innerHTML

        const previousLiveInputInstance = LiveInputs.returnLastClassInstance()
        const dataToSubmit = previousLiveInputInstance.dataToSubmit
        const updateParams = {
          ledgerId,
          name,
          objectId: parseInt(objectId),
          objectType,
          objectLedgerId: parseInt(objectLedgerId),
          valueType,
          [ownerType]: ownerId,
        }

        const liveInputs = new LiveInputs(parent, null, true)
        const modalParams = {
          ...updateParams,
          dataToSubmit: dataToSubmit,
          attemptToConfirmUnreview: parentdataset.attemptToConfirmUnreview,
          range,
          value,
          defaultValue,
          updatePath,
          external,
          ledgerLabel,
          afterUpdate: (response) => {
            liveInputs.replaceHtml(response)
            liveInputs.showUndo(response.auditIds)

            previousLiveInputInstance.clearDataToSubmit()
          },
        }

        window.modalCitizen.openModal('account-selector-modal', modalParams)
      })
    })
})
